import React, { useState } from "react";
import logo from "./../../assets/logo1.png";
import BurguerImg from "./../../assets/burguer.svg";
import CloseImg from "./../../assets/close.svg";
import "./style.css";
import { Link } from "react-router-dom";

function Header({isOnTop = false}) {
  const [isMenuOpen, setIsMenuOpen ]= useState(false);
  const handleIsMenuOpen = () => setIsMenuOpen(!isMenuOpen);

  return (
    <header className={!isOnTop ? `on-body ${!isMenuOpen ? '': 'opened'}`: ''}>
      <button onClick={handleIsMenuOpen} className='btn-close'>
        {isMenuOpen? <img width={16} src={CloseImg} alt="X" />:  <img width={16} src={BurguerImg} alt="X" />}
      </button>
      <Link  className={'logo'}  to="/#personal">
        <img id="logo1" src={logo} alt="logo" />
      </Link>
      <div className={` ${!isMenuOpen ? 'closed': ''}`}>
        <ul className="header-list">
          <li className="header-item">
            <Link to="/#personal">Home</Link>
          </li>
          <li className="header-item">
            <Link to="/#renders">Portfólio</Link>
          </li>
          <li className="header-item">
            <Link to="/#outsourced">Terceirizados</Link>
          </li>
          <li className="header-item">
            <Link to="/#services">Serviços</Link>
          </li>
          <li className="header-item">
            <Link to="/#whoami">Quem sou</Link>
          </li>
          <li className="header-item">
            <Link to="/#contact">Contato</Link>
          </li>
        </ul>
      </div>
    </header>
  );
}

export default Header;
